import React from 'react';
import { StyledBadge, StyledContainer } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
export const Badge = ({ semanticShape, label, alert, labelPosition = 'trailing', count, className, 'aria-label': ariaLabel, 'data-testid': dataTestId, margin }) => {
    const countIsNumber = typeof count === 'number';
    const countLimited = countIsNumber && count < 100 ? count : '99+';
    if (label) {
        return (React.createElement(StyledContainer, { className: className, labelPosition: labelPosition, "data-testid": dataTestId, "aria-label": ariaLabel, margin: margin },
            labelPosition === 'leading' && label,
            React.createElement(StyledBadge, { alert: alert, semanticShape: semanticShape, count: countIsNumber }, alert ? '!' : countIsNumber ? countLimited : null),
            labelPosition === 'trailing' && label));
    }
    return (React.createElement(StyledBadge, { alert: alert, count: countIsNumber, semanticShape: semanticShape, "aria-label": ariaLabel, className: className, "data-testid": dataTestId, margin: margin }, alert ? '!' : countIsNumber ? countLimited : null));
};
//# sourceMappingURL=index.js.map